import { Category } from 'lib/_types'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

export const CategoriesGrid = ({
  categories,
  onClick,
}: {
  categories: Category[]
  onClick: (category: Category) => void
}) => (
  <div className="CategoriesGrid">
    {categories.map((category) => {
      return (
        <div className="CategoriesGrid__item" key={category.id}>
          <ImageLoader
            className="CategoriesGrid__item__image"
            url={category.icon_url}
            onClick={() => onClick(category)}
          />

          <div className="CategoriesGrid__item__label">{category.title}</div>
        </div>
      )
    })}
  </div>
)
